import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { form_control, Permission, PermissionValues } from "projects/sepidz-web-framework/src/lib/models";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { AccountService } from "projects/sepidz-web-framework/src/lib/services";
import { ErrorDialogService } from "projects/sepidz-web-framework/src/lib/services/error-dialog/error-dialog.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CommonService } from "../../../../../../sepidz-web-framework/src/lib/services/common.service";
import { SelectorService } from "../base/selector.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "dynamic-form",
  templateUrl: "dynamic-form.component.html",
  styleUrls: ["dynamic-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicFormComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChildren("input") private inputElems: QueryList<ElementRef>;
  @Input() isSaved: boolean = false;
  @Input() isSavedFinish: boolean = false;
  @Input() submitButtonDisabled: boolean = false;
  @Input() isSubmitted: boolean = false;
  @Input() defaultHeight: number = 40;
  @Input() group: UntypedFormGroup;
  @Input() erroremessage: string;
  @Input() hasCheckBoxLookUpTree: boolean = true;
  @Input() apiName: string;
  @Input() areaName: string;
  @Input() label: string;
  @Input() model: any;
  @Input() saveLabel: string;
  @Input() savingLabel: string;
  @Input() noChangeLabel: boolean = false;
  @Input() isShowModal: boolean = true;
  @Input() noSubmit: boolean = false;
  @Input() noClose: boolean = false;
  @Input() showCloseBtn: boolean = true;
  @Input() secondClass: string;
  @Input() columns: Array<form_control>;
  @Input() hasDefault: boolean;
  @Input() hasfocus: string;
  @Input() samePermission: boolean;
  @Input() filterLookUp: any[] = [];
  @Input() hasManageAccess = false;
  @Output() cancelChange = new EventEmitter();
  @Output() submitChange = new EventEmitter();
  @Output() valueChange = new EventEmitter<any>();
  @Output() valueChangeWithName = new EventEmitter<any>();
  @Output() valueChangeByApiName = new EventEmitter<any>();
  @Output() onRowSelected = new EventEmitter<any>();
  @Output() onRowsSelected = new EventEmitter<any>();
  @Output() CompleteData = new EventEmitter<any>(true);

  public createPermission: PermissionValues = Permission.createPermission;
  public editPermission: PermissionValues = Permission.editPermission;
  public deletePermission: PermissionValues = Permission.deletePermission;

  isNewRow: boolean = false;
  isloaded: boolean = false;
  ngUnsubscribe = new Subject<void>();
  managePermission: boolean;
  headerLabel: string;

  @HostListener("window:keydown", ["$event"])
  cs(e: KeyboardEvent) {
    if (e.ctrlKey && (e.key.toUpperCase() === "S" || e.key === "س")) {
      e.preventDefault();
      this.onsubmitChange(this.group);
    }
  }

  constructor(
    private accountService: AccountService,
    private cd: ChangeDetectorRef,
    protected errorDialogService: ErrorDialogService,
    private selectorService: SelectorService,
    private translate: TranslateService,
    public CommonService: CommonService
  ) {}

  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }

  ngOnInit() {
    this.defaultHeight = this.defaultHeight ?? 40;
    this.selectorService.onFocused = false;
    this.selectorService.submitted$.next(this.isSaved);
    this.selectorService.submitted$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      this.isSaved = x;
      this.isSubmitted = x;
      this.cd.markForCheck();
    });
    this.managePermission = this.canManageForms();
    this.cd.markForCheck();
  }

  ngAfterViewInit(): void {
    this.isloaded = true;
    this.inputElems?.first?.nativeElement?.focus();
    if (this.group) this.group.markAsUntouched();
    this.headerLabel = this.formViewCaption();
    this.cd.markForCheck();
  }

  canManageForms(): boolean {
    if (!this.areaName || !this.apiName) return true;
    this.isNewRow = this.model["State"] === RowState.New;
    if (this.isloaded || this.hasManageAccess) return true;
    return this.accountService.userHasPermission(
      `${this.areaName}:${this.apiName}`,
      !this.samePermission ? Permission.managePermission : Permission.samePermission
    );
  }

  formViewCaption(): string {
    if (this.noChangeLabel) return this.label;
    return `${this.translate.instant("ClientApp.Projects.FrameWorkShell.Shared.Controls.Form.Show")} ` + this.label;
  }

  isValid(form: UntypedFormGroup) {
    let valid: boolean = this.erroremessage === undefined;
    if (!valid) this.isSaved = false;

    Object.keys(form.controls).forEach((key) => {
      if (form.controls[key].invalid) {
        valid = false;
      }
    });
    if (!valid) this.isSaved = false;
    return valid;
  }
  onsubmitChange(form: UntypedFormGroup) {
    this.isSubmitted = true;
    form.markAllAsTouched();
    this.cd.markForCheck();
    this.selectorService.onSubmited.next(true);
    if (!this.columns || !this.columns.some((x) => x.formVisible) || form.valid || form.disabled) {
      this.isSaved = true;
      this.submitChange.emit();
      this.cd.markForCheck();
    }
  }

  onCancelChange() {
    this.group.markAllAsTouched();
    this.cd.markForCheck();
    this.selectorService.onSubmited.next(true);
    this.cancelChange.emit();
  }
}
